import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useAuthAxios from "../../hooks/useAuthAxios";
import useAxios from "../../hooks/useAxios";
import Modal from "../../utils/Modal";
import { toast } from "react-toastify";

import Pagination from "../../utils/Pagination";
import ChevronLeft from "../../utils/ChevronLeft";
import ChevronRight from "../../utils/ChevronRight";
import DeleteIcon from "../../utils/DeleteIcon";
import EditIcon from "../../utils/EditIcon";
import IF from "../../utils/IF";
import AddIcon from "../../utils/AddIcon";
import ChevronDoubleLeft from "../../utils/ChevronDoubleLeft";
import ChevronDoubleRight from "../../utils/ChevronDoubleRight";
import SearchIcon from "../../utils/SearchIcon";
import Select from "react-select";
import DeleteModal from "../../utils/DeleteModal";
import Loader from "../../hocs/Loader";

const Todo = () => {
  const compname = "Todo";
  const app_url = "todos";
  const axios = useAuthAxios();
  const [response, error, loading, axiosFetch, responseData] = useAxios();
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [id, setId] = useState("");
  const [search, setSearch] = useState("");
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const [isEdit, setIsEdit] = useState(false);
  const [loadingSpin, setLoadingSpin] = useState(false);

  const event_id = localStorage.getItem("id");
  const [pageSize, setPageSize] = useState({
    value: 10,
    label: 10,
  });

  const pageSizeOptions = [
    { value: 10, label: 10 },
    { value: 15, label: 15 },
    { value: 20, label: 20 },
    { value: 30, label: 30 },
    { value: 100, label: 100 },
  ];

  const onChangePageSize = (e) => {
    setPageSize(e);
    axiosFetch({
      axiosInstance: axios,
      method: "GET",
      url: `${app_url}?page_size=${e.value}&search=${search}&event=${event_id}`,
    });
  };

  const getData = () => {
    axiosFetch({
      axiosInstance: axios,
      method: "GET",
      url: `${app_url}?page_size=${pageSize.value}&search=${search}&event=${event_id}`,
    });
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  const resetForm = () => {
    reset({
      content: "",
    });
    setIsEdit(false);
    setOpen(false);
  };

  const onSubmit = (data) => {
    data.event = event_id;

    if (data.id) {
      const url = `${app_url}/${data.id}`;
      const method = "PUT";
      postData(data, url, method);
    } else {
      const url = `${app_url}`;
      const method = "POST";
      postData(data, url, method);
    }
  };

  const onShowEditModal = (data) => {
    const fields = ["id", "content", "is_completed"];
    fields.forEach((field) => setValue(field, data[field]));
    setIsEdit(true);
    setOpen(true);
  };

  const onShowDeleteModal = (id) => {
    setId(id);
    setOpenDelete(true);
  };

  const onDelete = () => {
    const url = `${app_url}/${id}`;
    const method = "DELETE";
    postData("", url, method);
  };

  const fetchPage = (pageNumber) => {
    const new_url = `${app_url}?page=${pageNumber}&page_size=${pageSize.value}&search=${search}&event=${event_id}`;

    axiosFetch({
      axiosInstance: axios,
      method: "GET",
      url: `${new_url}`,
    });
  };

  const postData = async (data, url, method) => {
    setLoadingSpin(true);
    await axios[method.toLowerCase()](url, data).then(
      (result) => {
        setLoadingSpin(false);
        toast.success(result.data.message);
        resetForm();
        getData();
        setOpenDelete(false);
      },
      (error) => {
        setLoadingSpin(false);
        if (error.response.status === 403) {
          toast.error(error.response.data.detail);
        } else {
          if (error.response.data.message) {
            toast.error(error.response.data.message);
          } else if (error.response.data.content) {
            toast.error(error.response.data.content[0]);
          } else if (error.response.data.non_field_errors) {
            toast.error(error.response.data.non_field_errors[0]);
          }
        }
      }
    );
  };

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearch(searchValue);
    axiosFetch({
      axiosInstance: axios,
      method: "GET",
      url: `${app_url}?page_size=${pageSize.value}&event=${event_id}&search=${searchValue}`,
    });
  };

  const handleCheckBox = (data) => {
    let values = data;
    values.is_completed = !data.is_completed;
    onSubmit(values);
  };

  return (
    <>
      {(loading || loadingSpin) && <Loader />}
      <section
        className="rounded bg-white 
        shadow-md w-full  h-fit  
        px-4 sm:px-6 lg:px-8 py-4"
      >
        <div className="mx-auto">
          <h1 className="text-3xl font-normal text-gray-900">
            {`${compname}s`}
          </h1>
        </div>
        <div className="flex justify-end">
          <button
            onClick={() => setOpen(true)}
            title="Add"
            className="m-1 px-2 py-2 border border-green-500 rounded text-sm font-medium text-white bg-green-500 hover:bg-green-600 focus:outline-none "
          >
            <AddIcon />
          </button>
        </div>
        <div>
          <div className="overflow-x-auto sm:-mx-4 lg:-mx-8 p-6">
            <div className="py-4 flex flex-wrap  gap-y-4">
              <div className="flex-auto w-64 md:max-w-sm lg:max-w-sm4">
                <label className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-gray-300">
                  Search
                </label>
                <div className="relative">
                  <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                    <SearchIcon />
                  </div>
                  <input
                    type="search"
                    className="block p-4 pl-10 
                        w-full text-base text-gray-900
                        border-1 rounded-md border-opacity-50 border-gray-600
                        focus:ring-0 focus:border-gray-600 focus:text-gray-900 focus: border-1"
                    placeholder="Search..."
                    onChange={(e) => handleSearch(e)}
                    required
                  />
                </div>
              </div>
              <div className="flex-auto w-32">
                <div className="flex justify-end">
                  <p className="px-4 text-sm text-gray-600">Rows per page:</p>
                  <Select
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 6,
                      border: 1,
                      colors: {
                        ...theme.colors,
                        text: "gray",
                        primary25: "lightgray",
                        primary: "#4b5563",
                      },
                    })}
                    defaultValue={pageSize}
                    onChange={(pageSize) => {
                      onChangePageSize(pageSize);
                    }}
                    options={pageSizeOptions}
                  />
                </div>
              </div>
            </div>
            {!loading && !error && !responseData.length > 0 && (
              <p>No Data to Display</p>
            )}
            <IF condition={responseData.length > 0}>
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr className="text-gray-700 uppercase tracking-wider">
                    <th className="px-4 py-3 text-left text-xs"></th>
                    <th className="px-4 py-3 text-left text-xs">Task</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {responseData.map((data, i) => (
                    <tr
                      key={i}
                      className="whitespace-no-wrap
                    text-sm text-gray-600 py-4"
                    >
                      <td className="px-4 py-3 w-2">
                        <div className="relative">
                          <input
                            className="text-slate-600 focus:ring-slate-300 border-gray-400 peer rounded-md w-6 h-6  top-7 left-4 "
                            id={data.id}
                            name={data.id}
                            type="checkbox"
                            checked={data.is_completed}
                            onChange={() => handleCheckBox(data)}
                          />
                        </div>
                      </td>
                      <td
                        className={`px-4 py-3 ${
                          data.is_completed
                            ? "line-through text-gray-400"
                            : "text-gray-600"
                        }`}
                      >
                        {data.content}
                      </td>
                      <td className="flex">
                        <button
                          onClick={() => onShowEditModal(data)}
                          title="Edit"
                          type="button"
                          className="m-1 px-2 py-2 border 
                        border-blue-500 rounded 
                        text-sm font-medium 
                        text-white bg-blue-500 
                        hover:bg-blue-600 focus:outline-none "
                        >
                          <EditIcon />
                        </button>
                        <button
                          onClick={() => onShowDeleteModal(data.id)}
                          title="Delete"
                          type="button"
                          className="m-1 px-2 py-2 border 
                          border-red-600 rounded text-sm 
                          font-medium text-white 
                          bg-red-600 hover:bg-red-700 
                          focus:outline-none "
                        >
                          <DeleteIcon />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <Pagination data={response}>
                <div
                  onClick={() => fetchPage(response.first)}
                  className={`relative inline-flex 
                  items-center px-2 py-2 rounded-l-md 
                  border border-gray-300 bg-white text-sm 
                  font-medium
                  ${
                    response.current !== response.first
                      ? "text-gray-500"
                      : "text-gray-200"
                  } 
                  ${
                    response.current !== response.first
                      ? "hover:bg-gray-100"
                      : "hover:bg-white"
                  } `}
                >
                  <span className="sr-only">First</span>
                  <ChevronDoubleLeft />
                </div>
                <div
                  onClick={() => fetchPage(response.current - 1)}
                  className={`relative inline-flex 
                  items-center px-2 py-2 
                  border border-gray-300 bg-white text-sm 
                  font-medium
                  ${response.previous ? "text-gray-500" : "text-gray-200"} 
                  ${
                    response.previous ? "hover:bg-gray-100" : "hover:bg-white"
                  } `}
                >
                  <span className="sr-only">Previous</span>
                  <ChevronLeft />
                </div>
                <span className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700">
                  Page {response.current} of {response.last}
                </span>
                <div
                  onClick={() => fetchPage(response.current + 1)}
                  className={`relative inline-flex 
                  items-center px-2 py-2 
                  border border-gray-300 bg-white text-sm 
                  font-medium 
                  ${response.next ? "text-gray-500" : "text-gray-200"}
                  ${response.next ? "hover:bg-gray-100" : "hover:bg-white"}`}
                >
                  <span className="sr-only">Next</span>
                  <ChevronRight />
                </div>
                <div
                  onClick={() => fetchPage(response.last)}
                  className={`relative inline-flex 
                  items-center px-2 py-2 rounded-r-md 
                  border border-gray-300 bg-white text-sm 
                  font-medium 
                  ${
                    response.current !== response.last
                      ? "text-gray-500"
                      : "text-gray-200"
                  }
                  ${
                    response.current !== response.last
                      ? "hover:bg-gray-100"
                      : "hover:bg-white"
                  }`}
                >
                  <span className="sr-only">Last</span>
                  <ChevronDoubleRight />
                </div>
              </Pagination>
            </IF>
          </div>
        </div>
        <Modal
          modalHeader={isEdit ? `Edit ${compname}` : `New ${compname}`}
          open={open}
        >
          <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <div className="mt-4 relative p-6">
              <div className="grid  grid-cols-1 pb-4 gap-6">
                <label className="relative" htmlFor="content">
                  <input
                    id="content"
                    name="content"
                    type="text"
                    className={`text-gray-700 text-base font-light h-12 w-full px-4
                            border-1 rounded-md border-opacity-50 outline-none
                            ${
                              errors.content
                                ? "border-red-600 focus:border-red-600"
                                : "border-gray-600"
                            } 
                            focus:ring-0 focus:border-gray-600 focus:text-gray-900 focus: border-1
                            transition duration-200`}
                    placeholder="Task"
                    {...register("content", {
                      required: true,
                      pattern: /^[a-zA-Z\s]+$/,
                    })}
                  />
                  <span
                    className="
                  text-base text-gray-900
                  text-opacity-80  left-0 top-4
                  mx-2 px-2 absolute input-text
                  transition duration-200"
                  >
                    Task
                  </span>
                  {errors.content && errors.content.type === "required" && (
                    <p className="text-red-600 p-2 font-light">
                      This field is required
                    </p>
                  )}
                  {errors.content && errors.content.type === "pattern" && (
                    <p className="text-red-600 p-2 font-light">
                      Only alphabet characters are allowed
                    </p>
                  )}
                </label>
              </div>
            </div>
            <div className="flex py-4 px-6 justify-end">
              <button
                onClick={() => resetForm()}
                type="button"
                className="m-1 py-2 px-4 border-0 border-transparent text-md font-medium rounded-md border-gray-300 text-gray-700 hover:bg-gray-50 focus:outline-none sm:text-sm"
              >
                <span>Cancel</span>
              </button>
              <button
                type="submit"
                className="m-1 py-2 px-4 border border-transparent text-md font-medium rounded-md text-black bg-yellow-400 hover:bg-yellow-500 focus:outline-none sm:text-sm"
              >
                <span>{isEdit ? "Update" : "Create"}</span>
              </button>
            </div>
          </form>
        </Modal>
        <DeleteModal
          open={openDelete}
          itemName={compname}
          onDelete={() => onDelete()}
          close={() => setOpenDelete(false)}
        />
      </section>
    </>
  );
};
export default Todo;
